/**
 * Toast Notification Directive
 * */
bookingApp.directive('skToast',['$rootScope',function($rootScope, $window){
    return {
        link: function(scope, element, attrs){
            element.addClass('hide');
            scope.$watch('session.showToast',function(newVal, oldVal){
                if(newVal) {
                    var showingMessage = true;
                    // set toast text and show
                    element.find('.message-text').text(session.toastMessage);
                    element.removeClass('hide');
                    element.removeClass('initial-hide');
                    // set timeout
                    window.setInterval(function () {
                        if (showingMessage) {
                            // hide the toast
                            showingMessage = false;
                            element.addClass('hide');
                            scope.$apply(function () {
                                scope.session.showToast = false;
                            });
                        }
                    }, 3000);
                }
            });
        }
    }
}]);
